import "../Style/ToggleSwitch.css"


function ToggleSwitch(props) {

    const handleToggle = (e) => {
        console.log("Toggled switch", e.target.value, e.target.checked);
        props.togglefunction(e.target.checked);
    }

    return (
        <div>
            <label className="switch">
                <input type="checkbox" onChange={handleToggle} defaultChecked={props.defaultChecked} disabled={props.disabled} />
                {props.disabled?<span className="slider round disable"></span>:<span className="slider round"></span>}

            </label>
            {props.content}
        </div>
    );
}

export default ToggleSwitch;